import { http } from './http';

export const siteService = {
  // Get all sites
  getSites: (params = {}) => {
    return http.get('/api/admin/sites', { params });
  },

  // Get single site
  getSite: (id) => {
    return http.get(`/api/admin/sites/${id}`);
  },

  // Create new site
  createSite: (siteData) => {
    return http.post('/api/admin/sites', siteData);
  },

  // Update site
  updateSite: (id, siteData) => {
    return http.put(`/api/admin/sites/${id}`, siteData);
  },

  // Delete site
  deleteSite: (id) => {
    return http.delete(`/api/admin/sites/${id}`);
  },
};
